/**
 * Configuración de preguntas para el módulo de Clima Organizacional.
 */

export type QuestionType = 'likert' | 'enps' | 'open';

export type ClimateDimension =
  | 'leadership'
  | 'communication'
  | 'growth'
  | 'wellbeing'
  | 'belonging'
  | 'loyalty'
  | 'general';

export interface ClimateQuestion {
  id: string;
  text: string;
  dimension: ClimateDimension;
  type: QuestionType;
  placeholder?: string;
}

export const CLIMATE_QUESTIONS: ClimateQuestion[] = [
  // ─── Liderazgo ───
  {
    id: 'l1',
    dimension: 'leadership',
    type: 'likert',
    text: 'Mi jefe directo me proporciona retroalimentación clara para mejorar mi desempeño.',
  },
  {
    id: 'l2',
    dimension: 'leadership',
    type: 'likert',
    text: 'Confío en que la dirección de la empresa está tomando las decisiones correctas.',
  },
  {
    id: 'l3',
    dimension: 'leadership',
    type: 'likert',
    text: 'Los objetivos de mi puesto están claramente definidos.',
  },
  // ─── Comunicación ───
  {
    id: 'c1',
    dimension: 'communication',
    type: 'likert',
    text: 'La información importante fluye de manera oportuna dentro de mi equipo.',
  },
  {
    id: 'c2',
    dimension: 'communication',
    type: 'likert',
    text: 'Siento que mi opinión es escuchada y tomada en cuenta.',
  },
  {
    id: 'c3',
    dimension: 'communication',
    type: 'likert',
    text: 'Existe colaboración y apoyo mutuo entre los diferentes departamentos.',
  },
  // ─── Crecimiento ───
  {
    id: 'r1',
    dimension: 'growth',
    type: 'likert',
    text: 'Cuando realizo un buen trabajo, recibo el reconocimiento que merezco.',
  },
  {
    id: 'r2',
    dimension: 'growth',
    type: 'likert',
    text: 'Tengo oportunidades reales de aprender y crecer profesionalmente aquí.',
  },
  {
    id: 'r3',
    dimension: 'growth',
    type: 'likert',
    text: 'Considero que mi compensación es justa en relación con mis tareas.',
  },
  // ─── Bienestar ───
  {
    id: 'b1',
    dimension: 'wellbeing',
    type: 'likert',
    text: 'Cuento con las herramientas necesarias para realizar mi trabajo con calidad.',
  },
  {
    id: 'b2',
    dimension: 'wellbeing',
    type: 'likert',
    text: 'La empresa promueve un equilibrio saludable entre vida laboral y personal.',
  },
  {
    id: 'b3',
    dimension: 'wellbeing',
    type: 'likert',
    text: 'Mi carga de trabajo es manejable y permite cumplir mis objetivos.',
  },
  // ─── Pertenencia ───
  {
    id: 'p1',
    dimension: 'belonging',
    type: 'likert',
    text: 'Me siento motivado(a) y comprometido(a) con el éxito de la organización.',
  },
  {
    id: 'p2',
    dimension: 'belonging',
    type: 'likert',
    text: 'Me siento orgulloso(a) de decir que trabajo en esta empresa.',
  },
  {
    id: 'p3',
    dimension: 'belonging',
    type: 'likert',
    text: 'Si tuviera la oportunidad, volvería a elegir trabajar aquí.',
  },
  // ─── Lealtad (eNPS) ───
  {
    id: 'enps',
    dimension: 'loyalty',
    type: 'enps',
    text: 'En una escala del 0 al 10, ¿qué tanto recomendarías esta empresa a un amigo como un lugar para trabajar?',
  },
  // ─── Feedback Abierto ───
  {
    id: 'open_comments',
    dimension: 'general',
    type: 'open',
    text: '¿Tienes algún comentario o sugerencia adicional para mejorar la empresa?',
    placeholder: 'Escribe aquí tus comentarios (opcional)...',
  },
];
